// ============================================================
// Certifications Module - Scroll Animations
// ============================================================

export function initCertifications() {
    const certCards = document.querySelectorAll('.cert-card');

    // Intersection Observer for scroll animations
    const observerOptions = {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('visible');
            }
        });
    }, observerOptions);

    certCards.forEach(card => {
        observer.observe(card);
    });
}
